import React from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import Interaction from 'components/Practice/Interaction';

const OnDemandPracticeInteraction = props => {
  const { interaction, question } = props;

  const addResponse = newResponse => {
    const route =
      routes.ON_DEMAND_PRACTICE.CREATOR.CONVERSATIONS.QUESTIONS.INTERACTIONS.RESPONSES.CREATE(
        question.id,
        interaction.id,
      );
    return request.post(route, newResponse);
  };

  const deleteResponse = responseId => {
    const route =
      routes.ON_DEMAND_PRACTICE.CREATOR.CONVERSATIONS.QUESTIONS.INTERACTIONS.RESPONSES.DELETE(
        question.id,
        interaction.id,
        responseId,
      );
    return request.delete(route);
  };

  const updateResponse = (responseId, body) => {
    const route =
      routes.ON_DEMAND_PRACTICE.CREATOR.CONVERSATIONS.QUESTIONS.INTERACTIONS.RESPONSES.UPDATE(
        question.id,
        interaction.id,
        responseId,
      );
    return request.put(route, body);
  };

  return (
    <Interaction
      addResponseApi={addResponse}
      deleteResponseApi={deleteResponse}
      updateResponseApi={updateResponse}
      {...props}
    />
  );
};
export default OnDemandPracticeInteraction;
